import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress, Stack, styled } from '@mui/material';
import { useState } from 'react';
import { putPublic } from '../../data/aws/s3/UserBlobs';
import { ActionIcons } from '../../Iconography';
import { ComponentMode, Severity } from '../../types/AppTypes';
const debug = process.env.REACT_APP_DEBUG && false;
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
/**
 * 2026 03: Used to put in S3 `private/`, now defaults to putting in S3 `public/`
 */
export default function FileSelectCard(props) {
    const { matchedPrimary, transactionFunctions, userFunctions, parentHooks, editMode = ComponentMode.EDIT } = props;
    debug && console.log('FileSelectCard has props', props);
    const [uploadProgress, setUploadProgress] = useState(0);
    debug && console.log('FileSelectCard has saveObject', transactionFunctions?.saveObject);
    const handleFileUpload = async (e) => {
        debug && console.log(e.target.files);
        const fileList = e.target.files;
        const directoryString = `${matchedPrimary.sk}/`;
        if (fileList) {
            for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
                const file = fileList[i];
                if (file.size > 5 * 1024 * 1024) {
                    window.alert(`File too big!\nUploads are limited to 5 megabytes.`);
                    continue;
                }
                const progressCallback = (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    setUploadProgress((loaded / total) * 100);
                    if (loaded === total)
                        setTimeout(() => setUploadProgress(0), 100);
                };
                try {
                    const uploadRes = await putPublic(directoryString, file, progressCallback);
                    debug && console.log('uploadRes', uploadRes);
                    if (typeof parentHooks?.addKey === 'function') {
                        parentHooks.addKey(uploadRes);
                    }
                }
                catch (error) {
                    console.log('Error uploading file: ', error);
                    if (error instanceof Error)
                        userFunctions.setUserMessage({ id: matchedPrimary.sk, type: 'MessageBar', severity: Severity.error, label: error.name, content: error.message });
                }
            }
        }
    };
    return (_jsx(Stack, { direction: "row", children: _jsxs(Button, { component: "label", variant: "contained", tabIndex: -1, startIcon: _jsx(ActionIcons.Upload, {}), disabled: editMode === ComponentMode.VIEW, loading: 0 < uploadProgress, loadingPosition: "start", loadingIndicator: _jsx(CircularProgress, { variant: "determinate", value: uploadProgress, size: "1.5em" }), children: ["Upload photos", _jsx(VisuallyHiddenInput, { type: "file", accept: "image/*", multiple: true, onChange: handleFileUpload })] }) }));
}
